import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SearchItem from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';


function CareersFilter({ filters, search }) {
	return (
        <div className="row hero-slide_content hero-slide_content-search">
            <div className="large-4 large-push-2 column">
                <SearchItem search={search} />
            </div>
            <div className="large-4 large-push-2 column">
            {filters && filters.taxonomyFilters && <DropdownItem search={search} title='Where' options={filters.taxonomyFilters.locationDivision} name='locationDivision' istaxonomy={true} />}
            </div>
        </div>			
	);
}

CareersFilter.propTypes = {
    filters: PropTypes.object,
    search: PropTypes.object
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(CareersFilter);
